import { FormControl, ValidationErrors } from '@angular/forms';

export const startWithCharactersValidation = (control: FormControl): ValidationErrors | null => {
	if (control.value) {
		if (!/^[a-zA-Z0-9_-]/.test(control.value)) {
			return { startWithCharacters: true };
		}
	}

	return null;
};

export const notAllowedCharactersValidation = (control: FormControl): ValidationErrors | null => {
	if (control.value) {
		if (!/^[a-zA-Z0-9.#@$_ -]*$/.test(control.value)) {
			return { notAllowedCharacters: true };
		}
	}

	return null;
};
